import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-64fe541a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }

import BorrowLender from '@/components/Content/BorrowLender.vue'
import HowItWorks from '@/components/Content/HowItWorks.vue'
// import About from '@/components/Content/About.vue'
// import PwnTeamAndAdvisors from '@/components/Content/PwnTeamAndAdvisors/PwnTeamAndAdvisors.vue'
// import JoinCommunity from '@/components/Content/JoinCommunity.vue'
import Footer from '@/components/Footer.vue'
import Chains from './Chains.vue'
import Backers from './Backers.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'Content',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(HowItWorks),
      _createVNode(BorrowLender),
      _createVNode(Chains),
      _createVNode(Backers),
      _createVNode(Footer)
    ])
  ]))
}
}

})